export default function Spacer({width, height}) {
  return (
    <div style={{
      width,
      height
    }}>
    </div>
  )
}